import { JsonObject, JsonProperty } from "ta-json";

import type { Nullable } from "..";

/**
 * Defines the property copy options resource.
 */
@JsonObject()
export class PropertyCopyOptionResource {
    /**
     * Gets or sets the name of the property.
     */
    @JsonProperty("property")
    property: string;

    /**
     * Gets or sets the copy method.
     */
    @JsonProperty("method")
    method: string;

    /**
     * Gets or sets the new value for the property.
     */
    @JsonProperty("new_value")
    newValue: Nullable<string>;

    constructor(property: string, method: string, newValue: Nullable<string>) {
        this.property = property;
        this.method = method;
        this.newValue = newValue ?? null;
    }
}
